export default "__VITE_ASSET__CFSVQ8Ah__"